import React from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

/** Below this width the card grid is usually touch-driven, where dragging tiles is unreliable. */
export const MOVE_MODE_NOTE_MAX_WIDTH = 900;
export const MOVE_MODE_NOTE_TEXT = 'Move and resize work best on desktop.';

/**
 * REQ-012: Lauren found Move Mode does nothing on her phone. Until drag works on touch,
 * tell people where it does work. Shown only on narrow (phone/tablet) widths, next to
 * the Move/Resize toggle in each card editor.
 */
export function MoveModeDesktopNote({ color = '#5f6670', style }) {
  const { width } = useWindowDimensions();
  if (width >= MOVE_MODE_NOTE_MAX_WIDTH) return null;
  return (
    <View
      style={[{ flexDirection: 'row', alignItems: 'center', gap: 6, marginBottom: 8 }, style]}
      accessibilityRole="text"
    >
      <Ionicons name="desktop-outline" size={14} color={color} />
      <Text style={{ fontSize: 12, lineHeight: 16, color, flexShrink: 1 }}>{MOVE_MODE_NOTE_TEXT}</Text>
    </View>
  );
}

export default MoveModeDesktopNote;
